import type { QueryClient } from "@tanstack/react-query";

export function invalidateSalesCache(
  queryClient: QueryClient,
  options?: { appointmentId?: string | null },
): void {
  queryClient.invalidateQueries({ queryKey: ["sales-list"] });
  queryClient.invalidateQueries({ queryKey: ["finalized-appointments"] });

  if (options?.appointmentId) {
    queryClient.invalidateQueries({
      queryKey: ["sale-by-appointment", options.appointmentId],
    });
  }
}

